import ImagesMainBannerFebruaryBottleOfTheMonthWebp from '@/public/images/main-banner/february/bottle_of_the_month.webp';
import ImagesMainBannerFebruaryMacallanWebp from '@/public/images/main-banner/february/macallan.webp';

export { ImagesMainBannerFebruaryBottleOfTheMonthWebp, ImagesMainBannerFebruaryMacallanWebp };
